import React from 'react';

import { useInterval } from './useInterval';
import { AbstractMedia } from '../types/AbstractMedia';

type Option = {
  defaultDuration?: number,
  onChange?: (index: number, media: AbstractMedia | undefined) => void,
};

export function useSlideRotator(medias: AbstractMedia[], {
  defaultDuration = 2,
  onChange,
}: Option = {}) {
  const [currentSlide, setCurrentSlide] = React.useState<[number, AbstractMedia | undefined, AbstractMedia | undefined]>(
    [0, medias[0], medias[1 % medias.length]]
  );

  const next = React.useCallback(() => {
    setCurrentSlide(([i]) => {
      const newIndex = (i + 1) % medias.length;
      const newNextIndex = (newIndex + 1) % medias.length;
      return [newIndex, medias[newIndex], medias[newNextIndex]];
    });
  }, [medias]);

  const duration = (currentSlide[1]?.time ?? defaultDuration) * 1000;

  useInterval(next, duration);

  React.useEffect(() => {
    onChange?.(currentSlide[0], currentSlide[1]);
  }, [currentSlide, onChange]);

  return {
    activeMedia: currentSlide[1],
    nextMedia: currentSlide[2],
    duration,
    index: currentSlide[0],
    next,
  };
}
